import React, {useState} from "react";
import {Tab, TabContent, TabPanel, TabsContainer, TabsList} from "./styles";

const Tabs = ({ tabs, defaultTab = 0 }) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  return (
    <TabsContainer>
      <TabsList>
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            isActive={activeTab === index}
            onClick={() => setActiveTab(index)}
          >
            {tab.label}
          </Tab>
        ))}
      </TabsList>
      <TabContent>
        {tabs.map((tab, index) => (
          <TabPanel key={index} isActive={activeTab === index}>
            {tab.content}
          </TabPanel>
        ))}
      </TabContent>
    </TabsContainer>
  );
};

export default Tabs;